import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { QuestionType, QuizType } from "app/types";
import React from "react";

interface TableHeaderProps {
  order: "asc" | "desc";
  orderBy: string;
  handleSortRequest: (property: keyof QuestionType) => void;
  translate: (key: string) => string;
  QUIZ_TYPES_CONTANTS: {
    AUDIOMETRY: number;
    COGNITIVE: number;
  };
  quiz: QuizType;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  QUIZ_TYPES_CONTANTS,
  handleSortRequest,
  order,
  orderBy,
  quiz,
  translate,
}) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>{translate("screens_quiz_list_actions")}</TableCell>
        <TableCell
          sortDirection={orderBy === "arrangeQuestionSequence" ? order : false}
        >
          <TableSortLabel
            active={orderBy === "arrangeQuestionSequence"}
            direction={orderBy === "arrangeQuestionSequence" ? order : "asc"}
            onClick={() => handleSortRequest("arrangeQuestionSequence")}
          >
            {translate("labels_sequence")}
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === "quest" ? order : false}>
          <TableSortLabel
            active={orderBy === "quest"}
            direction={orderBy === "quest" ? order : "asc"}
            onClick={() => handleSortRequest("quest")}
          >
            {translate("screens_quiz_list_questions")}
          </TableSortLabel>
        </TableCell>
        <TableCell>{translate("labels_answers")}</TableCell>
        <TableCell sortDirection={orderBy === "rightAnswer" ? order : false}>
          <TableSortLabel
            active={orderBy === "rightAnswer"}
            direction={orderBy === "rightAnswer" ? order : "asc"}
            onClick={() => handleSortRequest("rightAnswer")}
          >
            {translate("screenApp_results_rightResponse")}
          </TableSortLabel>
        </TableCell>

        {+quiz.type !== QUIZ_TYPES_CONTANTS.AUDIOMETRY ? (
          <TableCell sortDirection={orderBy === "fragranceId" ? order : false}>
            <TableSortLabel
              active={orderBy === "fragranceId"}
              direction={orderBy === "fragranceId" ? order : "asc"}
              onClick={() => handleSortRequest("fragranceId")}
            >
              {+quiz.type === QUIZ_TYPES_CONTANTS.COGNITIVE
                ? "Categoria Cognitiva"
                : translate("screens_collectionDevice_table_fragrance")}
            </TableSortLabel>
          </TableCell>
        ) : (
          <TableCell
            sortDirection={
              orderBy === "categoryCognitiveQuestionId" ? order : false
            }
          >
            <TableSortLabel
              active={orderBy === "categoryCognitiveQuestionId"}
              direction={
                orderBy === "categoryCognitiveQuestionId" ? order : "asc"
              }
              onClick={() => handleSortRequest("categoryCognitiveQuestionId")}
            >
              {translate("screens_collectionDevice_table_audiometry")}
            </TableSortLabel>
          </TableCell>
        )}
        <TableCell sortDirection={orderBy === "type" ? order : false}>
          <TableSortLabel
            active={orderBy === "type"}
            direction={orderBy === "type" ? order : "asc"}
            onClick={() => handleSortRequest("type")}
          >
            {translate("screenApp_quiz_questionType")}
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === "createdAt" ? order : false}>
          <TableSortLabel
            active={orderBy === "createdAt"}
            direction={orderBy === "createdAt" ? order : "asc"}
            onClick={() => handleSortRequest("createdAt")}
          >
            {translate("screens_quiz_list_created")}
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === "updatedAt" ? order : false}>
          <TableSortLabel
            active={orderBy === "updatedAt"}
            direction={orderBy === "updatedAt" ? order : "asc"}
            onClick={() => handleSortRequest("updatedAt")}
          >
            {translate("screens_quiz_list_updated")}
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default TableHeader;
